import { Button, Typography } from '@mui/material'

// Types
import type { TextButtonProps } from '@/types/components/atoms/button/text'

const PrimaryButtonAtom = (props: TextButtonProps) => {
	// Props
	const { text, type, loading, size, color, disabled, startIcon, endIcon, onClick, sx } = props

	return (
		<Button
			variant="contained"
			type={type}
			loading={loading}
			size={size}
			color={color}
			disabled={disabled}
			startIcon={startIcon}
			endIcon={endIcon}
			disableElevation
			onClick={onClick}
			sx={{
				p: 2,
				...(size === 'small' && { p: 1.25 }),
				...(size === 'medium' && { p: 1.5 }),
				fontSize: 16,
				fontWeight: 600,
				textTransform: 'inherit',
				lineHeight: 1.5,
				borderRadius: 1,
				...(!color ? { color: '#fff', bgcolor: '#171717' } : color === 'inherit' ? { color: 'grey.900', bgcolor: 'grey.100' } : {}),
				'& .MuiListItemIcon-root': {
					minWidth: 24,
					mr: 1
				},
				'& .MuiSvgIcon-root': {
					fontSize: 24,
					...(!color && { color: '#fff' })
				},
				...sx
			}}
		>
			<Typography
				component="span"
				sx={{
					display: 'inline-block',
					fontSize: 16,
					fontWeight: 600,
					lineHeight: 1.5,
					textOverflow: 'ellipsis',
					whiteSpace: 'nowrap',
					overflow: 'hidden'
				}}
			>
				{text}
			</Typography>
		</Button>
	)
}

export default PrimaryButtonAtom
